import React, { Fragment, useState } from "react";
import { Col, Card, CardHeader, CardBody, Form, Label, Row } from "reactstrap";
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, Link } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { toast } from "react-toastify";
import { AddCustomer, Address, Customer, Email, Name, MobileNo, Save, CustomerId, Alternativephone } from "../../../Constant";
import { addCustomer, addCustomerRole } from "../../../CommonUrl";
import { useSelector } from "react-redux";
import { postClientUrlWithToken } from "../../../Utils/restUtils";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Transparentspinner from "../../Common/Loader/Transparentspinner";

const schema = yup.object().shape({
  address: yup.string().required().label('Address').max(60, 'Address must be at most 60 characters'),
  name: yup.string().required().label('Name'),
  email: yup.string().email('Inavlid email format').required().label('Email'),
  phonenumber: yup.string().required().label("Phone number"),
});

const CustomerForm = () => {
  const { register, handleSubmit, control, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(schema),
  });
  const authState = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    const countryCode = data.countryCode;
    const phoneNumber = data.phonenumber;
    const altPhoneNumber = data.altphonenumber;

    if (phoneNumber.startsWith(countryCode)) {
      setLoading(true);
      const callNumber = phoneNumber.slice(countryCode.length);
      const altCallNumber = altPhoneNumber.slice(countryCode.length);
      const postRequest = {
        // subscriber_id: data.CustomerId,
        first_name: data.name,
        email: data.email,
        country_code: data.countryCode,
        mobile: callNumber,
        address: data.address,
        alt_mobile: altCallNumber
      };
      const addCustomerResponse = await postClientUrlWithToken(
        authState.apiUrl, authState.userRole === 1 ? addCustomer : addCustomerRole, postRequest
      );
      if (addCustomerResponse.status === 200) {
        if (addCustomerResponse.data.status === true) {
          navigate(`${process.env.PUBLIC_URL}/customers/customer`);
          toast.success(addCustomerResponse.data.message);
        } else {
          {
            addCustomerResponse.data.message.map((msg) => {
              toast.error(msg);
              setLoading(false)
            })
          }
        }
      } else if (addCustomerResponse.status >= 400 && addCustomerResponse.status <= 405) {
        navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
      } else if (addCustomerResponse.status >= 500 && addCustomerResponse.status <= 505) {
        navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
      } else {
        navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
      }
      setLoading(false);
    }
  };

  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <Breadcrumbs mainTitle={Customer} parent="Customers" title={Customer} />
      <Card>
        <CardHeader className="pb-0">
          <H3>{AddCustomer}</H3>
        </CardHeader>
        <CardBody>
          <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
            <Row className="g-3 pt-3">
              {/* <Col md="6">
                <Label className="form-label" for="customerId">{CustomerId}</Label>
                <input className="form-control" id="customerId" type="text" {...register("CustomerId")} />
              </Col> */}
              <Col md="6">
                <Label className="form-label" for="name">{Name} <span className="requireStar">*</span></Label>
                <input className="form-control" id="name" type="text" {...register("name", { required: true })} />
                <p className="text-danger">{errors.name?.message}</p>
              </Col>
              <Col md="6">
                <Label className="form-label" for="email">{Email} <span className="requireStar">*</span></Label>
                <input className="form-control" id="email" type="email" {...register("email", { required: true })} />
                <p className="text-danger">{errors.email?.message}</p>
              </Col>
            </Row>
            <Row className="g-3 pt-3">
              <Col md="6">
                <Label className="form-label" >{MobileNo} <span className="requireStar">*</span></Label>
                <Controller
                  name="phonenumber"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Phone number is required" }}
                  render={({ field }) => (
                    <PhoneInput
                      {...field}
                      country={"bn"}
                      enableSearch={true}
                      onChange={(value, country) => {
                        setValue("countryCode", country.dialCode);
                        field.onChange(value);
                      }}
                      inputStyle={{
                        width: "100%",
                        height: "46px",
                        padding: "10px",
                        paddingLeft: "50px",
                        fontSize: "16px",
                        borderRadius: "8px",
                        borderColor: "rgba(83, 70, 134, 0.1019607843)",
                      }}
                      searchClass="none"
                    />
                  )}
                />
                <span className="text-danger">{errors.phonenumber && errors.phonenumber.message}</span>
              </Col>
              <Col md="6">
                <Label className="form-label" >{Alternativephone}</Label>
                <Controller
                  name="altphonenumber"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <PhoneInput
                      {...field}
                      country={"bn"}
                      enableSearch={true}
                      onChange={(value, country) => {
                        setValue("countryCode", country.dialCode);
                        field.onChange(value);
                      }}
                      inputStyle={{
                        width: "100%",
                        height: "46px",
                        padding: "10px",
                        paddingLeft: "50px",
                        fontSize: "16px",
                        borderRadius: "8px",
                        borderColor: "rgba(83, 70, 134, 0.1019607843)",
                      }}
                      searchClass="none"
                    />
                  )}
                />
              </Col>
            </Row>
            <Row className="g-3 pt-3">
              <Col>
                <Label className="form-label">{Address} <span className="requireStar">*</span></Label>
                <textarea className="form-control"
                  {...register("address", { required: true, maxLength: 60 })}
                  maxLength={60}
                />
                <p className="text-danger">{errors.address?.message}</p>
                {errors.address?.type === 'maxLength' && <p>Address must not exceed 160 characters</p>}
              </Col>
            </Row>
            <div className="d-flex justify-content-center mt-3 gap-2">
              <Btn attrBtn={{ color: "primary" }} type="submit">
                {Save}
              </Btn>
              <Link to="/customers/customer" className="btn btn-light" type="button">
                Cancel
              </Link>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Fragment>
  );
};
export default CustomerForm;
